// helpers/roleHelpers.js
export const isSuperAdmin = (user) => user.role === 'superadmin';
